// Highlight color constants for floor plan visualization.
//
// Selected ELEMENTS (walls, windows, doors, objects) use a pink/purple scheme:
// the plan is drawn in greys, browns and blues, and pink is the one hue
// nothing else on the canvas claims. The selected ROOM is different — see
// FLOOR_FILL.

export const HIGHLIGHT_COLORS = {
  // Primary highlight colors
  PRIMARY: '#ff66ff', // Pink/purple for outlines and main elements
  PRIMARY_FILL: '#ffb3ff', // Light pink/purple for fills
  PRIMARY_DARK: '#cc00cc', // Darker pink/purple for better contrast

  // Secondary highlight — same color the 3D viewer's multi-select / "Apply
  // to all ___" toggle paints peer fixtures with (Tailwind blue-400). Used
  // for items that are group-related to, but not directly part of, the
  // active selection.
  SECONDARY: '#60a5fa',

  // Floor/room highlighting — the selected room's polygon.
  //
  // Themed to the accent (`--color-accent`, #DD9B4A) while the element
  // highlights below stay pink, because these are answering different
  // questions. This is the SCOPE you are working in — the same thing the
  // minimap tints, the breadcrumb names and the layers tray marks active, so
  // it should look like them. The element highlights mark a thing you have
  // grabbed, on a plan full of greys, where pink is unmistakable.
  //
  // Literal rather than `var(--color-accent)`: these feed `ctx.fillStyle`, and
  // canvas silently ignores a CSS variable — see `utils/minimapPalette.js` for
  // the same constraint and the token-resolving version of this.
  FLOOR_FILL: 'rgba(221, 155, 74, 0.22)',
  FLOOR_STROKE: 'rgba(221, 155, 74, 0.85)',

  // Line widths (relative to scale)
  THIN_LINE: (scale) => Math.max(0.01, 1 / scale),
  MEDIUM_LINE: (scale) => Math.max(0.02, 3 / scale),
  THICK_LINE: (scale) => Math.max(0.03, 4 / scale),
  EXTRA_THICK_LINE: (scale) => Math.max(0.05, 4 / scale),

  // Wall selection
  WALL_SELECTED: '#cc00cc', // Darker pink/purple for better visibility
  WALL_SELECTED_FILL: '#ffb3ff', // Light pink/purple fill

  // Stretch preview / error (editable wall measurements)
  PREVIEW: '#ff8c00', // Orange — affected measurements during stretch preview
  ERROR: '#e53935', // Red — walls that would collapse / blockers in preview
};

// Non-selected element colors
export const ELEMENT_COLORS = {
  // Windows
  WINDOW: '#0066cc',

  // Doors
  DOOR: '#8B4513',

  // Walls
  WALL_DEBUG: '#404040',
  WALL_NORMAL: '#404040',
  WALL_BLACK: 'black',

  // Objects
  OBJECT_BATHROOM: '#808080', // Medium grey for bathroom fixtures
  OBJECT_NORMAL: '#D0D0D0', // Light grey for other objects
  OBJECT_STROKE: '#333333',

  // Openings
  OPENING: '#E0E0E0', // Light grey for openings
};
